import { isDefined } from '@aloft/toolkit-shared';
import { Block, Flex, Table, Tbody, Td, Th, Thead, Tr, Typography } from '@aloft/toolkit-sui';

import { AdjustmentSettingsHelperText } from '../../../components/AdjustmentSettingsHelperText.tsx';
import { selectComparableSalesChartData } from '../../../redux/features/selectors/selectComparableSalesChartData.ts';
import { COMMENTARY_TEXT } from '../consts.ts';

export const CommentaryListToSale = ({
  chartData,
  ratio,
  helperText,
}: {
  chartData: ReturnType<typeof selectComparableSalesChartData>;
  ratio?: number;
  helperText?: string;
}) => (
  <Flex flexDirection="column" gap={1} overflowX="auto">
    <Typography variant="h3">{COMMENTARY_TEXT['list-to-sale'].headerText}</Typography>
    <Table className="commentary-table">
      <Thead>
        <Tr>
          <Th />
          {chartData.map((data) => (
            <Th key={data.header}>
              <Typography variant="h5">{data.header}</Typography>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>
            <Typography variant="h5">DOM</Typography>
          </Td>
          {chartData.map((data) => (
            <Td key={data.header}>
              <Typography variant="body2">{data.DOM?.toString() ?? ''}</Typography>
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <Typography variant="h5">Original List Price</Typography>
          </Td>
          {chartData.map((data) => (
            <Td key={data.header}>
              <Typography variant="body2">{data.originalListPrice ?? ''}</Typography>
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <Typography variant="h5">Close Price</Typography>
          </Td>
          {chartData.map((data) => (
            <Td key={data.header}>
              <Typography variant="body2">{data.closePrice ?? ''}</Typography>
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <Typography variant="h5">SP as % LP</Typography>
          </Td>
          {chartData.map((data) => (
            <Td key={data.header}>
              <Typography variant="body2">{data.salePriceAsPercentageOfListPrice ?? ''}</Typography>
            </Td>
          ))}
        </Tr>
      </Tbody>
    </Table>
    <Block marginTop="1rem">
      <Typography variant="h3">
        List to sale price adjustment: {isDefined(ratio) ? `${ratio.toString()}%` : '-'}
      </Typography>
      {helperText && <AdjustmentSettingsHelperText helperText={helperText} />}
    </Block>
  </Flex>
);
